import { GameProviderId } from '@/enums/gameProviderId';
import { CasinoBannerItemProps } from '@/interfaces/casinoBanner';

export const banners: CasinoBannerItemProps[] = [
  // {
  //   id: 1,
  //   image: `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/banners/home/desk/1.webp`,
  //   link: '/bonus',
  //   title: 'free_spin_title',
  //   description: 'free_spin_description',
  //   provider: GameProviderId.Originals,
  //   color: '#855BE9',
  // },
  {
    id: 2,
    image: `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/banners/home/desk/6.webp`,
    link: '/bonus',
    title: 'lucky_wheel_title',
    description: 'lucky_wheel_description',
    provider: GameProviderId.Originals,
    color: '#E7C4D5',
  },
  {
    id: 3,
    image: `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/banners/home/desk/8.webp`,
    link: '/bonus',
    title: 'rakeback_title',
    description: 'rakeback_description',
    provider: GameProviderId.PragmaticPlay,
    color: '#474DBD',
  },
  {
    id: 4,
    image: `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/banners/home/desk/4.webp`,
    link: '/bonus',
    title: 'cashback_title',
    description: 'cashback_description',
    provider: GameProviderId.PGSoft,
    color: '#68B6F8',
  },
  {
    id: 5,
    image: `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/banners/home/desk/5.webp`,
    link: '/sports?bt-path=%2Flive',
    title: 'sports_cashback_title',
    description: 'sports_cashback_description',
    provider: GameProviderId.Originals,
    color: '#83EFF8',
  },
  {
    id: 6,
    image: `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/banners/home/desk/3.webp`,
    link: '/vip-club',
    title: 'vip_club_title',
    description: 'vip_club_description',
    provider: GameProviderId.PragmaticPlay,
    color: '#18C2BC',
  },
  /* {
    id: 7,
    image: `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/banners/home/desk/7.webp`,
    link: '/sports?bt-path=%2F2',
    title: 'basketball_title_label',
    description: 'basketball_description_label',
    provider: GameProviderId.Originals,
    color: '#42DFEE',
  },
  {
    id: 8,
    image: `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/banners/home/desk/8.webp`,
    link: '/games/tag/live_casino',
    title: 'live_casino_title_label',
    description: 'live_casino_description_label',
    provider: GameProviderId.Skywind,
    color: '#474DBD',
  },
  {
    id: 9,
    image: `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/banners/home/desk/2.webp`,
    link: '/sports?bt-path=%2Fsoccer-1',
    title: 'soccer_title_label',
    description: 'soccer_description_label',
    provider: GameProviderId.Originals,
    color: '#68B6F8',
  }, */
];
